import setUserToSentryScope from './setUserToSentryScope';
import tracking from "./tracking";

export default [setUserToSentryScope, ...tracking];